import LoginForm from "./loginForm.js";
import AuthTravelShell from "../../components/travel-theme/AuthTravelShell.js";

const Login = () => {
  return (
    <AuthTravelShell
      eyebrow="HackPrinceton traveler portal"
      title="Welcome aboard."
      description="Sign in to continue your application and follow every stop on your route to HackPrinceton Fall 2026."
      ticketCode="LOG IN"
    >
      <LoginForm />
    </AuthTravelShell>
  );
};

export default Login;
